import { handleActions } from "redux-actions";
import {
  getUserProfiles,
  getUserProfilesSuccess,
  getUserProfilesFailure,
  setProfileMonitoring,
  setProfileMonitoringSuccess
} from "../actions/ProfileList";

const profilesState = {
  loading: false,
  profiles: null,
  error: false
};

const profiles = handleActions(
  {
    [getUserProfiles]: (state, action) => {
      return { ...state, loading: true };
    },
    [getUserProfilesSuccess]: (state, action) => {
      const { payload } = action;
      return { ...state, profiles: payload, loading: false };
    },
    [getUserProfilesFailure]: (state, action) => {
      return { ...state, loading: false, error: true };
    }
  },
  profilesState
);
const monitoring = handleActions(
  {
    [setProfileMonitoring]: (state, action) => {
      const { payload } = action;
      return payload;
    },
    [setProfileMonitoringSuccess]: (state, action) => {
      return state;
    }
  },
  profilesState
);

export { profiles, monitoring };
